import React from 'react';
import CrossRoad from "../UI/Crossroad";

const Crossroad_9ABlue_13BRed = () => <CrossRoad coords="1745.000000, 1400.000000"/>;

export default Crossroad_9ABlue_13BRed;
